import classNames from 'classnames';
import dynamic from 'next/dynamic';
import type { FunctionComponent } from 'react';
import { Container } from '../../components/layout/grid';
import { Markdown } from '../../components/markdown';
import { Marquee as MarqueeComponent } from '../../components/marquee';
import type { MarqueeFragment } from '../../graphql/fragments/MarqueeFragment.graphql';
import { InvestorCard } from '../investor-card';
import { ImageCard } from './image-card';
import styles from './marquee.module.scss';
const MarqueeItem = dynamic(() => import('./marquee-item'));
export const Marquee: FunctionComponent<MarqueeProps> = ({
  heading,
  align,
  size,
  itemsCollection,
  imagesCollection,
  speed = 50,
  theme
}) => {
  return <div className={styles['container']} data-sentry-component="Marquee" data-sentry-source-file="marquee.tsx">
            {!!heading && <Container>
                    <div className={classNames(styles['heading-container'], align === 'left' && styles['left-align'])}>
                        <Markdown markdown={heading} tag='h3' typeStyle={{
          _: 'heading-sm',
          md: 'heading-lg'
        }} />
                    </div>
                </Container>}
            <MarqueeComponent speed={speed} pauseOnHover={false} data-sentry-element="MarqueeComponent" data-sentry-source-file="marquee.tsx">
                {imagesCollection?.items.map((image, index) => <ImageCard {...image} key={image.sys.id} index={index} />)}
                {itemsCollection?.items.map((item, index) => {
        if (item.type === 'Investor') {
          return <InvestorCard {...item} key={`${item.name}}`} index={index} />;
        }

        // default case is marquee item
        return <MarqueeItem {...item} key={`${item.copy}--${index}`} size={size ?? 'default'} theme={theme?.key ?? ''} />;
      })}
            </MarqueeComponent>
        </div>;
};
export default Marquee;
type MarqueeProps = Omit<MarqueeFragment, 'sys' | 'type'>;